import {Component, Inject} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {Meta, Title} from '@angular/platform-browser';
import {UtilitiesService} from '../../service/utilities.service';
import {StatePersistenceService} from '../../service/state.persistence.service';
import {BaseComponent} from '../../common/component/base/base.component';
import {Router} from '@angular/router';
import {BreadcrumbService} from '../../service/breadcrumb.service';

@Component({
    selector: 'your-utility-bill-after-solar',
    templateUrl: './your-utility-bill-after-solar.component.html',
    styleUrls: ['./../residential-solar.component.scss']
})
export class YourUtilityBillAfterSolarComponent extends BaseComponent {

    constructor(@Inject(DOCUMENT) public override document: Document,
                private title: Title,
                private meta: Meta,
                private utilities: UtilitiesService,
                private state: StatePersistenceService,
                router: Router,
                breadcrumbService: BreadcrumbService) {
        super(document, router, breadcrumbService);
    }
}
